import { NgClass, NgForOf } from '@angular/common';
import { Component, forwardRef, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TrailerFuelLevel } from 'shared/enums';
import { EnumHelper } from 'shared/helpers';

/**
 * @deprecated firefly-1-9758-ui will be removed after feature flag expires, use fuel-level.component
 */
@Component({
  selector: 'app-fuel-slider',
  templateUrl: './fuel-slider.component.html',
  styles: ``,
  imports: [MatSliderModule, NgForOf, NgClass, TranslateModule, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FuelSliderComponent),
      multi: true,
    },
  ],
})
export class FuelSliderComponent implements ControlValueAccessor {
  public isDisabled = false;

  public readonly sliderLabels: string[] = EnumHelper.toValueArray(TrailerFuelLevel);

  private _valueNumber = 0;

  public get valueNumber(): number {
    return this._valueNumber;
  }

  public set valueNumber(value: number) {
    this._valueNumber = value;
    this.onChange(this.mapToString(value));
  }

  private translateSvc = inject(TranslateService);

  public formatSliderLabel = (value: number): string => {
    return this.translateSvc.instant(`yardControl.lists.fuelLevel.${this.sliderLabels[value]}`);
  };

  public mapToString(numerical: number): string | null {
    switch (numerical) {
      case 0:
        return TrailerFuelLevel.Empty;
      case 1:
        return TrailerFuelLevel.Fuel15Percent;
      case 2:
        return TrailerFuelLevel.Fuel25Percent;
      case 3:
        return TrailerFuelLevel.Fuel35Percent;
      case 4:
        return TrailerFuelLevel.Fuel50Percent;
      case 5:
        return TrailerFuelLevel.Fuel65Percent;
      case 6:
        return TrailerFuelLevel.Fuel75Percent;
      case 7:
        return TrailerFuelLevel.Fuel85Percent;
      case 8:
        return TrailerFuelLevel.Full;
      default:
        return null;
    }
  }

  public mapToNumber(strFuelLevel: TrailerFuelLevel): number {
    switch (strFuelLevel) {
      case TrailerFuelLevel.Empty:
        return 0;
      case TrailerFuelLevel.Fuel15Percent:
        return 1;
      case TrailerFuelLevel.Fuel25Percent:
        return 2;
      case TrailerFuelLevel.Fuel35Percent:
        return 3;
      case TrailerFuelLevel.Fuel50Percent:
        return 4;
      case TrailerFuelLevel.Fuel65Percent:
        return 5;
      case TrailerFuelLevel.Fuel75Percent:
        return 6;
      case TrailerFuelLevel.Fuel85Percent:
        return 7;
      case TrailerFuelLevel.Full:
        return 8;
      default:
        return -1;
    }
  }

  // ControlValueAccessor stuff
  // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
  public onChange = (value: string | null): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouch = (): void => {};

  public writeValue(value: string | null): void {
    if (value === null) {
      this._valueNumber = -1;
    } else {
      this.valueNumber = this.mapToNumber(value);
    }
  }

  public registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => string): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
